import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { remove } from "sr/utils/axios";

export const deleteRegion = async (id: any) => {
  try {
    return await remove<ApiResponse<[]>>(`/user/regions/${id}`).then((res) => {
      if (res?.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e) {
    HandleApiError(e);
  }
};
